import React, { Component, useState, useEffect, useRef, useLayoutEffect } from 'react'

import { AnimatePresence, motion, useMotionValue, useTransform, animate, useScroll, useMotionValueEvent, useAnimationControls, motionValue } from "framer-motion"

import { NavLink, Link } from "react-router-dom"

import Modal from 'react-modal';

import IconButton from '../../elements/IconButton'
import Dropdown from '../../elements/ReactSelectDropdown'
import TextInput from '../../elements/TextInput'
import Button from '../../elements/Button'

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
]

const MONTH_OPTIONS = MONTH_NAMES.map((name) => ({ value: name, label: name }))

const Main = (props) => {

    {/*
    Props:
        monthSelector={true/false} - Selects a single month instead of a Friday week range - False by default
    */}

    function convertDateToShortFormat(dateString) {
        // Split the input date string into parts
        const [year, month, day] = dateString.split('-');
    
        // Extract the last two digits of the year
        const shortYear = year.slice(-2);
    
        // Return the formatted date
        return `${month}/${day}/${shortYear}`;
    }

    // const [startDate, setStartDate] = useState(convertDateToShortFormat(props.calStartDate))
    // const [endDate, setEndDate] = useState(convertDateToShortFormat(props.calEndDate))
    const defaultFriday = getRecentTuesdayAndUpcomingMonday()
    const [startDate, setStartDate] = useState(defaultFriday)
    const [endDate, setEndDate] = useState(defaultFriday)
    const [year, setYear] = useState(new Date().getFullYear())
    const [fridayWeeks, setFridayWeeks] = useState(getFridaysOfYear(year))
    const [month, setMonth] = useState(MONTH_NAMES[new Date().getMonth()])

    function formatDate(date) {
        return (date.getMonth() + 1).toString().padStart(2, '0') + '/' +
               date.getDate().toString().padStart(2, '0') + '/' +
               date.getFullYear().toString().slice(-2);
    }

    function getRecentTuesdayAndUpcomingMonday() {
        const today = new Date();
        const recentTuesday = new Date(today);
        const upcomingMonday = new Date(today);
    
        // Adjust recentTuesday to the most recent Tuesday or today if today is Tuesday
        while (recentTuesday.getDay() !== 2) {
            recentTuesday.setDate(recentTuesday.getDate() - 1);
        }
    
        // Adjust upcomingMonday to the next Monday if today is not Monday, or today if today is Monday
        while (upcomingMonday.getDay() !== 1) {
            upcomingMonday.setDate(upcomingMonday.getDate() + 1);
        }
    
        const fridayBetween = new Date(recentTuesday);
        while (fridayBetween.getDay() !== 5) {
            fridayBetween.setDate(fridayBetween.getDate() + 1);
        }
    
        const formatDate = (date) => {
            return (date.getMonth() + 1).toString().padStart(2, '0') + '/' +
                   date.getDate().toString().padStart(2, '0') + '/' +
                   date.getFullYear().toString().slice(-2);
        };
    
        return formatDate(fridayBetween);
    }

    function getFridaysOfYear(year) {
        year = Number(year)
        const dates = [];
        let currentDate = new Date(year, 0, 1);
    
        while (currentDate.getDay() !== 5) {
            currentDate.setDate(currentDate.getDate() + 1);
        }
    
        while (currentDate.getFullYear() === year) {
            const dateString = (currentDate.getMonth() + 1).toString().padStart(2, '0') + '/' +
                               currentDate.getDate().toString().padStart(2, '0') + '/' +
                               currentDate.getFullYear().toString().slice(-2);
            dates.push({ value: dateString, label: dateString });
    
            currentDate.setDate(currentDate.getDate() + 7);
        }
    
        return dates;
    }

    function getRecentFriday() {
        const today = new Date();
        const recentFriday = new Date(today);
    
        while (recentFriday.getDay() !== 5) {
            recentFriday.setDate(recentFriday.getDate() - 1);
        }
    
        return formatDate(recentFriday);
    }

    function getCurrentWeekFriday() {
        const today = new Date();
        const currentWeekFriday = new Date(today);
        const dayOfWeek = currentWeekFriday.getDay();
        const offset = 5 - dayOfWeek;
        currentWeekFriday.setDate(currentWeekFriday.getDate() + offset);
        return formatDate(currentWeekFriday);
    }

    function parseShortDate(dateString) {
        const [month, day, year] = dateString.split('/').map(Number);
        return new Date(2000 + year, month - 1, day);
    }

    const getYearsFrom2021ToNow = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        // Include next year so future weeks/months are selectable.
        for (let year = 2021; year <= currentYear + 1; year++) {
          years.push({ value: year.toString(), label: year.toString() });
        }
        return years;
    };

    useEffect(() => {
        setFridayWeeks(() => getFridaysOfYear(year))
    },[year])

    const handleSave = () => {
        if (props.monthSelector) {
            const monthIndex = MONTH_NAMES.indexOf(month)
            const payloadStartDate = new Date(Number(year), monthIndex, 1)
            const payloadEndDate = new Date(Number(year), monthIndex + 1, 0) // last day of the month

            props.filterDate(payloadStartDate, payloadEndDate)
            props.setIsOpen()
            return
        }

        const payloadStartDate = new Date(parseShortDate(startDate));
        const payloadEndDate = new Date(parseShortDate(endDate));

        payloadStartDate.setDate(payloadStartDate.getDate() - 3);
        payloadEndDate.setDate(payloadEndDate.getDate() + 3);

        props.filterDate(payloadStartDate, payloadEndDate);
        props.setIsOpen();
    }

    return (
        <div style={{width: 'auto', height: '450px', display: 'flex', flexDirection: 'column'}}>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'row'}}>
                <span style={{fontWeight: '500', fontSize: '20px', flexBasis: '99%'}}>{props.monthSelector ? 'Month Selector' : 'Week Selector'}</span>
                <IconButton img={false} colors={props.colors} Style={{borderRadius: '3px', backgroundColor: props.colors.border, width: '24px'}} size="16px">
                    <div onClick={props.setIsOpen} style={{paddingLeft: '3px', paddingRight: '3px'}}><span onClick={props.setIsOpen}>x</span></div>
                </IconButton>
            </div>
            <div style={{flexBasis: '10%', display: 'flex', flexDirection: 'column'}}>
                <span style={{fontWeight: '500', fontSize: '16px', marginTop: '30px'}}>Select a Year</span>
                <Dropdown colors={props.colors} onChange={(e) => setYear(e.label)} index={props.index} indexParent={props.indexParent} data={getYearsFrom2021ToNow()} width={195} value={year}>Test</Dropdown>
            </div>
            <div style={{flexBasis: '80%', display: 'flex', flexDirection: 'row'}}>
                {props.monthSelector ? (
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <span style={{fontWeight: '500', fontSize: '16px', marginTop: '30px'}}>Select a Month</span>
                        <Dropdown colors={props.colors} onChange={(e) => setMonth(e.label)} index={props.index} indexParent={props.indexParent} sort={false} data={MONTH_OPTIONS} width={195} value={month}>Test</Dropdown>
                    </div>
                ) : (
                    <>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <span style={{fontWeight: '500', fontSize: '16px', marginTop: '30px'}}>Select the Start Friday</span>
                            <Dropdown colors={props.colors} onChange={(e) => setStartDate(e.label)} index={props.index} indexParent={props.indexParent} data={fridayWeeks} width={195} value={startDate}>Test</Dropdown>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', marginLeft: '30px'}}>
                            <span style={{fontWeight: '500', fontSize: '16px', marginTop: '30px'}}>Select the End Friday</span>
                            <Dropdown colors={props.colors} onChange={(e) => setEndDate(e.label)} index={props.index} indexParent={props.indexParent} data={fridayWeeks} width={195} value={endDate}>Test</Dropdown>
                        </div>
                    </>
                )}
            </div>
            <Button colors={props.colors} onClick={handleSave} active={true} Style={{width: '200px', marginLeft: 'auto', marginTop: '20px'}}>Save</Button>
        </div>
    )
}

export default Main